import type { Note } from "@/core/types";

export function isNoteSelectable(note: Note): boolean {
  if (!note) return false;

  return note.note_state !== "draft" && note.note_state !== "rejected" && note.is_billable === true;
}
